var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticStyle:{"height":"4rem"},attrs:{"toggleable":"sm","type":"dark","variant":"primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }